const transactionTypeOptions: { [key: string]: string } = {
  All: 'All',
  'EFT Withdrawal': 'EFT Withdrawal',
  'EFT Funding': 'EFT Funding',
  'VoPayInstant Withdraw': 'VoPayInstant Withdraw',
  Refund: 'Refund',
  'Currency Conversion': 'Currency Conversion',
  'Interac Money Request': 'Interac Money Request',
  'Interac Bulk Payout': 'Interac Bulk Payout',
  'Inbound e-Transfer': 'Inbound e-Transfer',
  'Visa Direct Push': 'Visa Direct Push',
  'Credit Card': 'Credit Card',
  'Google Pay': 'Google Pay',
  'PayPal Withdrawal': 'PayPal Withdrawal',
  'Account Transfer': 'Account Transfer',
  Reversal: 'Reversal',
  'Bill Pay': 'Bill Pay',
  'Virtual Account Deposit': 'Virtual Account Deposit',
  'Virtual Account Funding': 'Virtual Account Funding',
  'Virtual Account Withdraw': 'Virtual Account Withdraw',
  'Virtual Account Wire': 'Virtual Account Wire',
};

export default transactionTypeOptions;
